var _class, _temp;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import t from 'prop-types';

var formatTiempo = function formatTiempo(tiempo) {
  if (isNaN(tiempo)) {
    return '--:--';
  }

  if (tiempo === Infinity) {
    // return '--:--'
    return '00:00';
  }

  var mm = Math.floor(tiempo / 60);
  var ss = Math.floor(tiempo % 60);

  if (mm < 10) {
    mm = '0' + mm;
  }

  if (ss < 10) {
    ss = '0' + ss;
  }

  return mm + ':' + ss;
};

var Tiempo = function Tiempo(_ref) {
  var tiempoActual = _ref.tiempoActual,
      tiempoTotal = _ref.tiempoTotal,
      clase = _ref.clase;
  return React.createElement('span', {
    className: clase ? clase : '',
    dangerouslySetInnerHTML: {
      __html: tiempoActual + '/' + tiempoTotal
    }
  });
};

Tiempo.propTypes = process.env.NODE_ENV !== "production" ? {
  tiempoActual: t.string,
  tiempoTotal: t.string,
  clase: t.string
  /**
   * Muestra una consola de audio
   * 
   * El audio se carga de la carpeta: "``contenido/``" 
   */

} : {};
var ConsolaAudio = (_temp = _class = function (_Component) {
  _inherits(ConsolaAudio, _Component);

  function ConsolaAudio(props) {
    _classCallCheck(this, ConsolaAudio);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.stop = function () {
      var audio = _this.audioRef.current;

      _this.setState({
        playing: false
      }, function () {
        audio.pause();
        audio.currentTime = 0;
      });
    };

    _this.play = function () {
      var audio = _this.audioRef.current;

      if (!_this.state.playing) {
        _this.setState({
          playing: true
        }, function () {
          return audio.play();
        });
      } else {
        _this.setState({
          playing: false
        }, function () {
          return audio.pause();
        });
      }
    };

    _this.seek = function (e) {
      var audio = _this.audioRef.current;

      var _e$target$getBounding = e.target.getBoundingClientRect(),
          x = _e$target$getBounding.x,
          width = _e$target$getBounding.width;

      var currentTime = audio.duration * (e.clientX - x) / width;

      if (!isNaN(currentTime)) {
        audio.currentTime = currentTime;
      }
    };

    _this.actualizarTiempo = function () {
      // const audio = e.currentTarget
      var audio = _this.audioRef.current;
      var currentTime = audio ? audio.currentTime : 0;
      var duration = audio ? audio.duration : Infinity;

      _this.setState({
        progreso: 100 * currentTime / duration,
        tiempoActual: formatTiempo(currentTime),
        tiempoTotal: formatTiempo(duration)
      }, function () {
        if (currentTime >= duration) {
          _this.stop();
        }
      });
    };

    _this.state = {
      playing: false,
      progreso: 0,
      tiempoActual: '00:00',
      tiempoTotal: '00:00'
    };
    _this.audioRef = React.createRef();
    return _this;
  }

  ConsolaAudio.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.audio !== this.props.audio) {
      this.setState({
        playing: false,
        progreso: 0,
        tiempoActual: '00:00',
        tiempoTotal: '00:00'
      });
    }
  }; // componentWillUpdate(nextProps, nextState) {
  //     if (this.props.audio !== nextProps.audio) {
  //         this.setState({
  //             playing: false,
  //             progreso: 0,
  //             tiempoActual: '00:00',
  //             tiempoTotal: '00:00'                    
  //         })
  //     }
  // }


  ConsolaAudio.prototype.componentDidMount = function componentDidMount() {
    var audio = this.audioRef.current;
    audio.load();
    audio.addEventListener('durationchange', this.actualizarTiempo);
    audio.addEventListener('timeupdate', this.actualizarTiempo);
  };

  ConsolaAudio.prototype.componentWillUnmount = function componentWillUnmount() {
    var audio = this.audioRef.current;
    audio.removeEventListener('durationchange', this.actualizarTiempo);
    audio.removeEventListener('timeupdate', this.actualizarTiempo);
  };

  ConsolaAudio.prototype.render = function render() {
    var _props = this.props,
        textoTrack = _props.textoTrack,
        audio = _props.audio;
    var _state = this.state,
        tiempoActual = _state.tiempoActual,
        tiempoTotal = _state.tiempoTotal;

    var _audio$split = audio.split(':'),
        nombreAudio = _audio$split[0],
        pista = _audio$split[1];

    var src = 'contenido/' + nombreAudio + '.mp3'; // const clasesPlay = "playConsolaAudio" + (this.state.playing ? ' activa' : '')

    var clasesPlay = "playConsolaMultimedia" + (this.state.playing ? ' activa' : '');
    var progresoStyle = {
      width: this.state.progreso + '%' // const tiempoActual = formatTiempo((this.audioRef.current && this.audio.current.currentTime) || 0)
      // const tiempoTotal = formatTiempo((this.audioRef.current && this.audio.current.duration) || 0)
      // const clasesConsolAudio = ["consolaAudio"]

    };
    var clasesConsolAudio = ["consolaMultimedia"];

    if (pista) {
      clasesConsolAudio.push('pista');
    }

    var stopDesactivado = this.audioRef.current === null || this.audioRef.current.currentTime === 0;
    return React.createElement('span', {
      className: clasesConsolAudio.join(' ')
    }, pista && React.createElement('div', {
      className: 'textosMultimedia'
    }, '' + textoTrack + pista, React.createElement(Tiempo, {
      tiempoActual: tiempoActual,
      tiempoTotal: tiempoTotal
    })), React.createElement('div', {
      className: clasesPlay,
      onClick: this.play
    }), React.createElement('div', {
      className: 'stopConsolaMultimedia' + (stopDesactivado ? ' desactivado' : ''),
      onClick: this.stop
    }), React.createElement('div', {
      className: 'barraConsolaMultimedia',
      onClick: this.seek
    }, React.createElement('div', {
      className: 'progresoConsolaMultimedia',
      style: progresoStyle
    }, React.createElement('div', {
      className: 'reguladorConsolaMultimedia'
    })), !pista && React.createElement(Tiempo, {
      tiempoActual: tiempoActual,
      tiempoTotal: tiempoTotal,
      clase: 'codigoTiempo'
    })), React.createElement('audio', {
      src: src,
      ref: this.audioRef,
      onDurationChange: this.actualizarTiempo
    }));
  };

  return ConsolaAudio;
}(Component), _class.defaultProps = {
  textoTrack: 'Track '
}, _temp);
ConsolaAudio.propTypes = process.env.NODE_ENV !== "production" ? {
  /** "audio:nombre-pista" */
  audio: t.string.isRequired,
  textoTrack: t.string
} : {};
export default ConsolaAudio;